import { get } from 'lodash/fp';
import getSettings from 'common/utils/settings';
import computeInvestment from 'common/model/simulation/dismemberedScpi/computeInvestment';

// Validations au niveau du champ pour le "Nombre de parts" d'une SCPI.
// Elles reprennent les règles des formValidate de la simulation afin de s'appliquer
// aussi dans la recommandation CIF (formulaire sans validate global).
// Le type (et la durée pour le démembrement) sont re-dérivés depuis le nom du champ
// et les valeurs du formulaire, pour rester indépendant du préfixe
// (data.* en simulation, name.* en recommandation).

export const validateParts = (value, allValues, props, name) => {
    const type = get(`${name.replace(/\.parts$/, '')}.type`, allValues);
    const minimumParts = getSettings(['simulation', 'scpi', type, 'minimumParts']);

    if (!value || value < minimumParts) {
        return `Un minimum de ${minimumParts} parts est requis`;
    }

    return undefined;
};

export const validateDismemberedParts = (value, allValues, props, name) => {
    const productName = name.replace(/\.parts$/, '');
    const operationName = name.replace(/\.products\[\d+\]\.parts$/, '');
    const type = get(`${productName}.type`, allValues);
    const duration = get(`${operationName}.duration`, allValues);

    const scpiType = getSettings(['simulation', 'dismemberedScpi', type]);

    if (!scpiType) {
        return undefined;
    }

    if (scpiType.minimumInvestment
        && scpiType.minimumInvestment > computeInvestment(duration)([{ type, parts: value }])) {
        return `Un investissement d'un minimum de ${scpiType.minimumInvestment}€ est requis`;
    }

    if (!scpiType.minimumInvestment && (!value || value < scpiType.minimumParts)) {
        return `Un minimum de ${scpiType.minimumParts} parts est requis`;
    }

    return undefined;
};
